// import { Avatar, Paper, Stack, Typography, Box, Button } from "@mui/material";
import React, { useCallback, useState , useEffect} from "react";
import { GetProfileImages } from "../DocumentDetails/slice";
import {
  Avatar,
  Paper,
  Stack,
  Typography,
  Box,
  Button,
  Modal,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { DEFAULT_AVATAR_URL } from "../../common/enum";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AvatarGroup from "@mui/material/AvatarGroup";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined"
import DetailsNotification from "../DashBoardView/Actions/ActionCard/Details/DetailsNotification";
import { getCancelCollectionDonationById ,markasread } from "../DashBoardView/slice";
import { getDonorDetailById } from "../CreateCollection/slice";
import Chip from "@mui/material/Chip";
import CheckIcon from "@mui/icons-material/Check";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
const NotificationCardSignalIR = ({ notification, t }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNotificationId, setSelectedNotificationId] = React.useState([]);
  const [donation, setdonation] = React.useState([]);
  const dispatch = useDispatch();
  const [entityDonation ,setEntityDonation] = React.useState([]);
  const handleClick = useCallback((notification) => {
      if (notification) {
        var notificationId = notification.entitySenderDetails.idNotification
        dispatch(markasread(notificationId))
        var donationId = notification?.entitySenderDetails?.idDonation;
        dispatch(getCancelCollectionDonationById(donationId))
          .unwrap()
          .then((res) => {
            
            const id = res?.donations?.donation.id;
            const year = new Date(
              res?.donations?.donation.createdDate
            ).getFullYear();
              setdonation(res.donations)
              setIsModalOpen(true);
              setSelectedNotificationId(notification)
              const data = {
                entityId: res.donations.donation.entityId,
              };
              dispatch(getDonorDetailById(data))
              .unwrap()
              .then((res)=>{
                setEntityDonation(res)
                //console.log(res)
              })
            // setDonationUid(`${year}${id}`);
          }).catch((err) => {
            console.error(err);
          });
      }
  }, []);


  const handleCloseModal = useCallback(() => {
    setSelectedNotificationId([]);
    setIsModalOpen(false);
  }, []);


  const [profileImages, setProfileImages] = useState(new Map());

  useEffect(() => {
    if (!notification) return;

    const entityDetails = notification.entityDetails;
    const entityId = entityDetails?.entityId;
    const profilePicture =
      entityDetails?.profilePicture &&
      entityDetails.profilePicture !== "string"
        ? entityDetails.profilePicture
        : notification.profilePicture &&
          notification.profilePicture !== "string"
        ? notification.profilePicture
        : null;

    if (!entityId || !profilePicture) return;

    // Evita refazer a requisição para a mesma entidade
    if (profileImages.has(entityId)) return;

    dispatch(GetProfileImages(profilePicture))
      .unwrap()
      .then((response) => {
        if (response?.isActive != null) {
          setProfileImages((prev) => {
            const newMap = new Map(prev);
            newMap.set(entityId, response.isActive);
            return newMap;
          });
        }else{
           setProfileImages((prev) => {
            const newMap = new Map(prev);
            newMap.set(entityId, DEFAULT_AVATAR_URL);
            return newMap;
          });
        }
      })
      .catch((err) => {
        console.warn("Erro ao buscar imagem:", err);
      });
  }, [notification, dispatch, profileImages]);

  const entityId = notification?.entityDetails?.entityId;
  const profileImageUri =
    entityId && profileImages.has(entityId)
      ? profileImages.get(entityId)
      : DEFAULT_AVATAR_URL;

  return (
    <>
    <Button
        variant="outlined"
        sx={{
          p: 1,
          m: 1,
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent: "space-between",
          alignItems: "flex-start",
          width: "-webkit-fill-available",
          color: "black"
        }}
        onClick={() =>
          handleClick(notification)
        }
        // id={"IdNotificacao"+notification.entitySenderDetails.idNotification}
      >
        <Chip
          label={notification.entitySenderDetails.isRead ? t("read") : t("unRead")}
          icon={
            notification.entitySenderDetails.isRead == true ? (
              <CheckIcon sx={{ color: "#1B727E", fontSize: "small" }} />
            ) : (
              <FiberManualRecordIcon
                sx={{ color: "pink", fontSize: "small" }}
              />
            )
          }
          sx={{
            backgroundColor: notification.entitySenderDetails.isRead ? "#E4F2E8" : "#ffcbcb82",
            // color: message.isRead ? "#1B727E" : "red",
            mx: 1,
            "& .MuiChip-label": {
              fontWeight: 600,
              fontFamily: "Poppins",
            },
            "& .MuiChip-icon": {
              color: notification.entitySenderDetails.isRead ? "#1B727E" : "red",
            },
          }}
        />
        {/* {notification.entitySenderDetails.isRead == false ?
            <Typography sx={{
              verticalAlign: "middle",
              boxSizing: "border-box",
              backgroundColor: "#E4F2E8",
              color: "#1B727E",
              marginLeft: "8px",
              marginRight: "8px",
              fontSize: "14px",
              fontWeight: "600",
              borderRadius: "29px",
              padding: "8px",
            }}
          >
              Nova notificação
            </Typography>
            :
            <Typography sx={{
              verticalAlign: "middle",
              boxSizing: "border-box",
              backgroundColor: "#ffc0003b",
              color: "#bd8f03",
              marginLeft: "8px",
              marginRight: "8px",
              fontSize: "14px",
              fontWeight: "600",
              borderRadius: "29px",
              padding: "8px",
            }}
          >
              Notificação lida
            </Typography>
          
          } */}
        <Stack direction={"column"}>
            <Stack direction="column" spacing={1}>
            <Stack direction="row" sx={{alignItems: "center"}}>
                <Avatar
                  alt={notification.entityDetails.entityName}
                  src={profileImageUri
                  }
                  sx={{
                    backgroundColor: "green",
                    width: "24px",
                    height: "24px"
                  }}
              />
              <Typography variant="body1" fontFamily={"Poppins"} mx={1}>
                {/* {new Date(
                notification?.donation?.donations?.donation.createdDate
                ).getFullYear()} */}
                {/* {notification.entitySenderDetails.codDoacao} */}
                <span title={`Código de doação`} >{notification.entitySenderDetails.codDoacao}{" "}</span> 
                {/* {new Date(
                  notification.collection.collection.createdDate
                ).getFullYear()} */}
                {/* {notification.entitySenderDetails.codRecetor} */}
                {notification.entitySenderDetails.codRecetor && 
                (<span  title={`Código de reservassss`} >{'('+ notification.entitySenderDetails.codRecetor+')'}</span>)
                }
                
              </Typography>
            </Stack>
            <Stack direction="row">
              <CalendarMonthOutlinedIcon />
              
              <Typography variant="body2" mx={1}>{<span>
                {/* {`${notification.updatedDate
                .toDate()
                .toLocaleString("pt", {
                  day:"numeric",
                  date: "numeric",
                  month: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                })}`} */}
                
                {`${new Date(notification.entitySenderDetails.updatedDate).toLocaleTimeString("pt", {
                      day:"numeric",
                      date: "numeric",
                      month: "numeric",
                      year: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      })}m`}
                
                </span>}</Typography>
            </Stack>
            <Stack direction="row">
              <StorefrontIcon />
              
                <Typography variant="body2" fontWeight={600} mx={1}>
              {notification.entitySenderDetails.entidadeEnvio}
              </Typography>
            </Stack>
            <Stack direction="row">
              <Typography
            variant="body2" fontWeight={600} 
              >
              {notification.entitySenderDetails.title}
              </Typography>
            </Stack>
            <Stack direction="row" >
              <Typography variant="body2" fontFamily={"Poppins"} sx={{ mb: 1 }} textAlign={"left"}>
                {notification.entitySenderDetails.note}
              </Typography>
              </Stack>
          </Stack>
        </Stack>
    </Button>
    <Modal open={isModalOpen} onClose={handleCloseModal}
    
    >
    {/* Your modal content goes here */}
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "69%", // Set the width as needed
        backgroundColor: "white",
        padding: 2,
        borderRadius: "4px",
        height: "600px"
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}  
      >
       <Typography variant="h5">
            {selectedNotificationId?.entitySenderDetails?.title}
          </Typography>
      
      <Button 
        sx={{backgroundColor: "#ffc3c3" , 
        padding: "0",
        minWidth: "35px",
        height: "35px",
        borderRadius: "4px"
      }} onClick={handleCloseModal} 
      >
        <CloseOutlinedIcon sx={{color: "#FF4842"}}/>
      </Button>
      </Box>
      <DetailsNotification
        component={"agenda"}
        collection={selectedNotificationId?.entitySenderDetails?.idDonation}
        donation={donation}
        all = {selectedNotificationId}
        t={t}
        entityDonation = {entityDonation}
      />
    </Box>
  </Modal>
  </>
  );
};

export default NotificationCardSignalIR;
